import { z } from "zod";
import { equipmentAttachmentSchema, equipmentFormSchema } from "../model";

export type Attachment = z.infer<typeof equipmentAttachmentSchema>;

export type EquipmentFormValue = z.infer<typeof equipmentFormSchema>;

export const enum EquipmentFormMode {
  Create = "create",
  Update = "update",
}

export interface CreateUpdateEquipmentDialogData {
  VOId?: string;
  dynamicVOId?: string;
  equipmentId?: string;
}
